import {IActionBase} from "./IActionBase";
import {Component} from "react";
import {ActionsManager} from "./actionsManager";
import {store} from "../../redux/storeConfig/store";
import {confirmationParams} from "../infrastructure/project-frame-container/globalModals/confirmationModal";
import {sendApplyooComponentsNotification} from "../infrastructure/useApplyooComponent";
import {utils_log} from "../utils/utils_log";

export class Confirmation extends Component implements IActionBase {

    actionCode = "action_AP_Confirmation";
    actionName = "Confirmation";

    // handleConfirmationModalCallback = () => {
    //
    // }

    Execute = (prmActionParameters:any,prmActionsManager:ActionsManager, prmElementObj?:any)=> {
        let callbackFunction = (prmConfirmObj: any) => {
            utils_log.writeToLog(prmConfirmObj)

            if (prmConfirmObj.result) {
                prmActionsManager.executeActions(prmActionParameters.ConfirmBtnActionsLst, prmElementObj.ElementObj)
            }
            else {
                prmActionsManager.executeActions(prmActionParameters.CancelBtnActionsLst, prmElementObj.ElementObj)
            }
        }
        //store.dispatch({type:'SET_ACTIONS', lstActions: [{"actionCode": "ConfirmMessage", "actionParams": prmActionParameters, "callbackFunction": callbackFunction}]});

        const params: confirmationParams = {
            //ConfirmationCallback: () => handleConfirmationModalCallback,
            ModalParameters: prmActionParameters,
            command: 'openConfirmationModal'
        }
        sendApplyooComponentsNotification("ApplyooGlobal", "ConfirmationModal", params)

        // var confirmObj = {
        //     title: prmActionParameters.MessageTitle,
        //     message: prmActionParameters.DisplayMessage,
        //     confirmButtonText: prmActionParameters.ConfirmBtnText,
        //     cancelButtonText: prmActionParameters.CancelBtnText,
        //     resultCallback: function (prmConfirmObj:any) {
        //         if (prmConfirmObj.result == "confirm") {
        //             applyoo.actionsManagerObj?.executeActions(prmActionParameters.ConfirmBtnActionsLst, prmElementObj.ElementObj)
        //
        //         }
        //         else {
        //             applyoo.actionsManagerObj?.executeActions(prmActionParameters.CancelBtnActionsLst, prmElementObj.ElementObj)
        //         }
        //     }
        // };
        //what is it?
        // APPLYOO.runtimeUtils.rootScopeObj.showConfirmMessage(confirmObj);

    }

}